module.exports = __webpack_public_path__ + "img/gb2238-80a-5-1.prt.e57c2314.jpg";